import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { useDracarRepairOrder } from '../../../actions/dracar'

// Functions
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission, hasAccess } from '../../../utils/auth'
import { triggerPopup } from '../../../actions/backdrop'

// Elements
import Divider from '../../elements/divider'
import Button from '../../elements/button'
import LabelWrapper from '../../elements/labelWrapper'
import Text from '../../elements/text'
import Grid from '../../elements/grid'
import DracarModal from '../../modals/DracarModal'
import PanelHeader from '../../elements/panelHeader'
import StatusBox from '../StatusBox'
import { SparePartModuleIcons } from '../../elements/icons'

class Dracar extends Component {
  constructor (props) {
    super(props)

    this.state = {
      orderNumber: this.props.order ? this.props.order.DracarRepairOrderId ? this.props.order.DracarRepairOrderId : '' : '',
      tempOrderNumber: '',
      state: 0,
      dracarAllowed: false,
      isSet: this.props.order ? this.props.order.DracarRepairOrderSet : false,

      showDracarModal: false,
      showSpinner: false
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.onChange = this.onChange.bind(this)
    this.getContent = this.getContent.bind(this)
    this.getOption = this.getOption.bind(this)
    this.useExistingOrder = this.useExistingOrder.bind(this)
    this.handleCreateRepairOrder = this.handleCreateRepairOrder.bind(this)
    this.getKeyLoopSystemName = this.getKeyLoopSystemName.bind(this)
    this.getRepairOrderAlias = this.getRepairOrderAlias.bind(this)
  }

  toggleModal (e) {
    const value = !this.state.showDracarModal
    this.setState({ showDracarModal: value }, () => {
      this.props.triggerPopup(value)
    })
  }

  onChange (e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleCreateRepairOrder (data) {
    this.setState({
      orderNumber: data.RepairOrder,
      isSet: data.IsSet
    }, () => {
      this.toggleModal()
      if (data.IsCreated) {
        // window.toastr.success(translation('16632').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()).replace('[RepairOrderAlias]', this.getRepairOrderAlias()), translation('13424'))
      } else {
        // window.toastr.success(translation('16819').replace('[RepairOrderAlias]', this.getRepairOrderAlias()), translation('13424'))
      }
    })
  }

  getKeyLoopSystemName () {
    switch (this.props.auth.accountingSystem) {
      case 4: return translation(15352)
      case 6: return translation(18138)
    }
    return ''
  }

  getRepairOrderAlias () {
    switch (this.props.auth.accountingSystem) {
      case 4: return translation(18149)
      case 6: return translation(18150)
    }
    return ''
  }

  getContent () {
    const {isSet, orderNumber} = this.state

    // const setChoice = (e) => {
    //   this.setState({
    //     state: e.target.value
    //   })
    // }

    const dracarIcon = isSet ? SparePartModuleIcons.OK : SparePartModuleIcons.Attention
    let dracarText = isSet ? `${translation(16633).replace('[RepairOrderAlias]', this.getRepairOrderAlias())}: ${orderNumber}` : translation(16609).replace('[KeyLoopSystem]', this.getKeyLoopSystemName())
    let statusColor = isSet ? 'green' : 'orange'

    let action
    if (hasSubscriptionPermission(this.props.auth, 10, 2) && !isSet) {
      action = this.toggleModal
    }
    return (
      <StatusBox
        onClick={!isSet ? action : null}
        icon={dracarIcon}
        color={statusColor}
        title={this.getKeyLoopSystemName()}
        subTitle={dracarText}
        chevron={this.state.showDracarModal}
      />
    )
  }

  useExistingOrder (e) {
    let data = { ExistingRepairOrderId: this.state.tempOrderNumber, OrderId: this.props.order.Id }
    this.props.useDracarRepairOrder(data).then(res => {
      this.setState({ orderNumber: res.data.RepairOrder, isSet: res.data.IsSet })
    })
    .catch(err => console.err(err))
  }

  getOption (val) {
    if (val === '1') {
      return (
        <div>
          <Divider />
          <Button size='l' onClick={this.toggleModal} labelText={translation('27')} />
        </div>
      )
    } else if (val === '2') {
      return (
        <div>
          <Divider />
          <LabelWrapper labelText={translation('16422')}>
            <Text id='DracarUserRepairOrderInput' name='tempOrderNumber' value={this.state.tempOrderNumber} onChange={this.onChange} />
          </LabelWrapper>
          <Button size='l' onClick={this.useExistingOrder} labelText={translation('1218')} />
        </div>
      )
    }

    return null
  }

  renderSetOrder () {
    if (this.state.showSpinner) {
      return (
        <Grid cols={['min-content', 1, 'max-content']} align='center'>
          <div className='divider' key='1' />
          <div className='invoice' key='2'>
            <span className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
            </span>
          </div>
        </Grid>
      )
    }

    return (
      <div>
        {this.getContent()}
      </div>
    )
  }

  render () {
    if (!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType)) return null
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    // if (this.props.auth.accountingSystem !== 4) return null

    return (
      <div>
        {this.props.hasHeader && <PanelHeader text='' />}
        <div className={'white__box invoice_wrapper'}>
          {this.renderSetOrder()}
        </div>
        {this.state.showDracarModal && (
          <DracarModal
            show={this.state.showDracarModal}
            onClose={this.toggleModal}
            onSuccess={this.handleCreateRepairOrder}
            order={this.props.order}
            handleToggle={this.toggleModal}
          />
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  useDracarRepairOrder
})(Dracar)



// WEBPACK FOOTER //
// ./src/app/shared/components/Dracar/index.js